"use strict";

var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _listingImage = require("../shared-components/image/listing-image");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var activityThumbs = [{
  external_id: 'meeting',
  cloud_img_id: '01_2x.jpg_h8wa6v',
  img_alt: 'Hold your next meeting in a unique space that is great for brainstorming and discussions',
  activity_name: 'Meetings'
}, {
  external_id: 'film-shoot',
  cloud_img_id: '02_2x.jpg_xwy139',
  img_alt: 'Film your next video shoot or production on unique sound stages',
  activity_name: 'Film Shoots'
}, {
  external_id: 'birthday-party',
  cloud_img_id: '03_2x.jpg_sukqqt',
  img_alt: 'Celebrate your next birthday party in a unique space and make it a memorable event',
  activity_name: 'Birthday Parties'
}, {
  external_id: 'photo-shoot',
  cloud_img_id: '04_2x.jpg_qtd9bg',
  img_alt: 'Find a unique studio for your next photo shoot, including fashion and apparel shoots',
  activity_name: 'Photo Shoots'
}, {
  external_id: 'workshop',
  cloud_img_id: '05_2x.jpg_lwf6wf',
  img_alt: 'Teach your next workshop in a unique space that is great for classes, coaching, and seminars',
  activity_name: 'Workshops'
}, {
  external_id: 'baby-shower',
  cloud_img_id: '06_2x.jpg_l77fo4',
  img_alt: 'Discover a unique venue to celebrate your baby shower, bridal shower, or engagement party',
  activity_name: 'Baby Showers'
}, {
  external_id: 'dinner',
  cloud_img_id: 'wewu37b2q78i6xxicevh.jpg',
  img_alt: 'Host your next meal in a space that is great for dinners, luncheons, and brunches',
  activity_name: 'Dinners'
}, {
  external_id: 'wedding-reception',
  cloud_img_id: '08_2x.jpg_hppcwh',
  img_alt: 'Find a large venue for your next event — whether a wedding, bar mitzvah, graduation, or sweet 16',
  activity_name: 'Weddings'
}, {
  external_id: 'off-site',
  cloud_img_id: 'qwg0nairbykf9gmxrnzr',
  img_alt: 'Hold your next strategy meeting or offsite in a unique venue',
  activity_name: 'Team Offsites'
}, {
  external_id: 'launch-event',
  cloud_img_id: '10_2x.jpg_bywnne',
  img_alt: 'Hold your next product launch or corporate event in a location that makes your company look its best',
  activity_name: 'Launch Parties'
}, {
  external_id: 'outdoor-event',
  cloud_img_id: 'cabkurjlhusgn2w4fccv',
  img_alt: 'Host your next outdoor event in a private backyard, rooftop, or patio',
  activity_name: 'Outdoor Events'
}, {
  external_id: 'performance',
  cloud_img_id: '12_2x.jpg_nvyqvc',
  img_alt: 'Find a unique venue for your next performance, recital, concert or screening',
  activity_name: 'Performances'
}];
var ActivityTileSearch = function ActivityTileSearch(_ref) {
  var searchFormProps = _ref.searchFormProps;
  var location = (0, _lodash.get)(searchFormProps, 'location', '');
  if (location) {
    location = location.toLowerCase().replace(/\,\s/g, '--').replace(/ /g, '-');
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row collection-thumbnails activity block-xs-center"
  }, (0, _lodash.map)(activityThumbs, function (act, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "activity-".concat(i),
      className: "col-xs-6 col-md-4 half-padding-sm"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "/s/?a=".concat(act.external_id, "&location=").concat(location || 'united-states')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "thumbnail marketing",
      "data-activity": act.external_id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hover-wrapper"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "img-container"
    }, /*#__PURE__*/_react.default.createElement(_listingImage.ListingImage, {
      alt: act.img_alt,
      imgId: act.cloud_img_id,
      ratio: 4 / 3,
      defaultWidth: 512,
      defaultHeight: 384,
      style: "cld-responsive cld-hidpi",
      widths: [256, 512]
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "caption"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "title ellipsis text-center h4 activity-header block-xs-center"
    }, act.activity_name)))));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "activity-button text-center col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "/plan/activities"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary btn-md classic"
  }, "See All Activities")))));
};
exports.ActivityTileSearch = ActivityTileSearch;